// Reference: https://www.youtube.com/watch?v=yAI9fbbH-rM
// https://apexcharts.com/react-chart-demos/column-charts/stacked-columns-100/

import { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { useTheme } from '../../../../contexts/ThemeContext'

const formatNumber = (val) => {
  const num = Number(val || 0);
  if (num === 0) return '0.00';
  return num.toPrecision(3);
}

const ApexPieChart = ({ data, labels, title, height }) => {
  const { theme } = useTheme()
  const [chartData, setChartData] = useState()

  useEffect(() => {
    if (theme === 'dark') {
      renderChart('#d1d5db')
    } else {
      renderChart('#6b7280')
    }
  }, [data, theme])

  function renderChart(labelColor) {
    const total = (data ?? []).reduce((a, b) => a + Number(b || 0), 0)

    setChartData({
      series: data ?? [],
      options: {
        chart: {
          fontFamily: 'DM Sans, sans-serif',
          type: 'donut',
        },

        labels: labels ?? [],

        // ✅ Different color palette from bar/line
        colors: [
          '#4F46E5',
          '#06B6D4',
          '#22C55E',
          '#F59E0B',
          '#EF4444',
          '#A855F7',
          '#14B8A6',
          '#F97316',
        ],

        plotOptions: {
          pie: {
            expandOnClick: true,
            donut: {
              size: '68%', // 🔥 bigger circle
              labels: {
                show: true,

                name: {
                  show: true,
                  fontSize: '14px',
                  color: labelColor,
                },

                value: {
                  show: true,
                  fontSize: '18px',
                  fontWeight: 600,
                  color: labelColor,
                  formatter: (val) => formatNumber(val),
                },

                total: {
                  show: true,
                  label: 'Total',
                  fontSize: '13px',
                  fontWeight: 600,
                  color: labelColor,
                  formatter: () =>
                    `${formatNumber(total)} tCO₂e`,
                },
              },
            },
          },
        },

        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '13px',
          fontFamily: 'Inter',
          fontWeight: 400,
          labels: {
            colors: labelColor,
            useSeriesColors: true,
          },
          formatter: (legendName, opts) => {
            const value = opts.w.globals.series[opts.seriesIndex]
            const pct = total > 0 ? ((value / total) * 100).toFixed(1) : 0
            return `${legendName}: ${formatNumber(value)} (${pct}%)`
          },
        },

        dataLabels: {
          enabled: false,
        },

        tooltip: {
          y: {
            formatter: (val) =>
              `${formatNumber(val)} tCO₂e`,
          },
        },

        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { width: 320 },
              legend: { position: 'bottom' },
            },
          },
        ],
      },
    })
  }

  return (
    <div className="bg-white dark:bg-darkbg4 rounded-xl border px-4 py-4">
      <h3 className="text-left px-4 mb-3">{title}</h3>

      {chartData && (
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="donut"
          height={height || 380} // 🔥 slightly taller default
        />
      )}
    </div>
  )
}

export default ApexPieChart
